import { ChildComponents } from '../../DnDChildComponents';
import { HeartLight, Plus, Percentage } from '../../../../../../../assets/svgs';

function Product_1({ customization, imgObj, productWidth }) {
  return (
    <div style={{ padding: customization?.padding, width: productWidth + '%' }}>
      <div
        className="height-auto-info border-box-new relative overflow-hidden  h-full flex flex-col "
        style={{
          borderWidth: 1,
          borderColor: customization?.borderColor,
          borderRadius: customization?.borderRadius,
          padding: customization?.betweenProductAndBorderPadding,
          boxShadow: ChildComponents[customization?.boxShadow]?.data,
        }}
      >
        <div className="absolute p-[6%] right-0 top-0">
          {customization?.heartIcon && (
            <div
              className="heart-fill-icon bdr-raduis-eight 2xl:rounded-[10px] rounded-[7.97341324459px] p-[5px] 2xl:p-[6.2708401617px]"
              style={{
                backgroundColor: customization?.productBorderColor,
              }}
            >
              <HeartLight
                className={'w-[12px] 2xl:w-[15.0500163881px] h-[12px] 2xl:h-[15.0500163881px] stroke-white'}
                style={{
                  stroke: customization?.productIconColor,
                }}
              />
            </div>
          )}
        </div>
        {customization?.discountIcon && (
          <div className="absolute  left-[7%] top-0 flex flex-col font-black	">
            <div
              className="heart-fill-icon bdr-raduis-eight text-[11.1627785424px] 2xl:text-[14px] leading-[12.7574611913px] 2xl:leading-[16px] 	text-white  p-[5px] 2xl:p-[6.2708401617px]"
              style={{
                backgroundColor: customization?.productBorderColor,
                color: customization?.productIconColor,
              }}
            >
              %<br />
              10
            </div>
          </div>
        )}

        <div
          className="shrink-0"
          style={{
            height: customization?.productImageHeight,
            backgroundColor: customization?.productBackgroundColor,
            padding: customization?.productImagePadding,
            backgroundColor:
              customization?.productBackgroundType === 'productBackgroundColor'
                ? customization?.productBackgroundColor
                : '',
            backgroundImage:
              customization?.productBackgroundType === 'productBackgroundImage'
                ? `url(${customization?.productBackgroundImage})`
                : '',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
          }}
        >
          {imgObj?.image?.type === "video" ?
            <video
              style={{
                objectFit: customization?.backgroundSize,
                borderRadius: customization?.productImageBorderRadius,
              }}
              autoPlay muted playsInline loop src={imgObj?.image?.src}

            ></video> :
            <img
              loading="lazy"
              src={imgObj?.image?.src}
              className="widgets-ratio-1 h-full w-full"
              alt=""
              style={{
                objectFit: customization?.backgroundSize,
                borderRadius: customization?.productImageBorderRadius,
              }}
            />
          }
        </div>
        <div
          className="flex flex-row border-t-2 h-full"
          style={{
            borderColor: customization?.productBorderColor,
            backgroundColor: customization?.productDetailBackgroundColor,
          }}
        >
          <div className="w-full flex flex-row  py-[7%] pl-[4%] pr-[5%] mt-auto">
            <div
              className="  shrink-1 flex items-start flex-col overflow-hidden "
              style={{ width: customization?.cartIcon ? '75%' : '100%' }}
            >
              <div
                className={`${customization?.productTextControl === 'clip'
                  ? 'truncate'
                  : customization?.productTextControl === 'double'
                    ? 'line-clamp-2'
                    : 'line-clamp-3'
                  } w-full text-left`}
                style={{
                  color: customization?.productTextColor,
                  fontSize: customization?.productTextSize,
                  lineHeight: customization?.productTextSize,
                  fontWeight: customization?.productTextWeight,
                  textAlign: customization?.productTextAlignment,
                  marginBottom: customization?.productTitleMarginBottom,
                }}
              >
                {imgObj?.image?.text}
              </div>
              <div className=" flex flex-row shrink-0 mt-[7%] flex-wrap  ">
                <div
                  className={` mr-[3px] mt-auto 2xl:mr-[3.76250409702px]  line-through text-left`}
                  style={{
                    fontSize: customization?.productDiscountPriceTextSize?.replace('px', '') * 0.9 + 'px',
                    color: customization?.productDiscountPriceColor,
                    fontWeight: customization?.productDiscountPriceWeight,
                    // lineHeight: customization?.productPriceTextSize?.replace('px', '') * 0.9 + 'px',
                  }}
                >
                  ₺1,000.00
                </div>
                <div
                  className="text-bold  text-left"
                  style={{
                    fontSize: customization?.productPriceTextSize?.replace('px', '') * 0.9 + 'px',
                    color: customization?.productPriceColor,
                    fontWeight: customization?.productPriceWeight,
                    // lineHeight: customization?.productPriceTextSize?.replace('px', '') * 0.9 + 'px',
                  }}
                >
                  ₺1,000.00
                </div>
              </div>
            </div>
            {customization?.cartIcon && (
              <div className="w-[25%]  shrink-0  h-full flex justify-center items-center my-auto ">
                <div
                  className="heart-fill-icon bdr-raduis-eight 2xl:rounded-[10px] rounded-[7.97341324459px] p-[1px] 2xl:p-[1.25416803234px] "
                  style={{
                    backgroundColor: customization?.productBorderColor,
                    color: customization?.productIconColor,
                  }}
                >
                  <Plus
                    circleHidden={true}
                    className={'w-[18px] 2xl:w-[22.5750245821px] h-[18px] 2xl:h-[22.5750245821px]'}
                    style={{
                      stroke: customization?.productIconColor,
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Product_1;
